import React, { useEffect, useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import {
  Controller,
  FormProvider,
  useForm,
} from "react-hook-form";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { GET, POST, PUT } from "../../helper/api";
import {
  EXTERNAL_PORT_FEE_CATEGORY_ID,
  renderLabelIngredientPriceHistoryOption,
} from "../../utils/Utils";
import BillExternalPortFeeCreateForm from "./BillExternalPortFeeCreateForm";
import BillHistory from "./BillExternalPortFeeHistory";


const BillExternalPortFeeCreate = () => {
  const history = useHistory();
  const { search } = useLocation();
  const duplicateId = new URLSearchParams(search).get("duplicateId");
  const params = useParams();
  const id = duplicateId || params.id;

  const methodForm = useForm({
    defaultValues: {
      numOfContainer: 0,
      departureTotalWeight: 1,
      ...(!id
        ? { departureTotalWeightAt: new Date() }
        : {}),
      departureMerchandiseWeight: 1,
      ...(!id ? { departureMerchandiseWeightAt: new Date() }
        : {}),
      departureTruckWeight: 0,
      ...(!id ? { departureTruckWeightAt: new Date() } : {}),

      destinationTotalWeight: 1,
      ...(!id ? { destinationTotalWeightAt: new Date() } : {}),
      destinationMerchandiseWeight: 1,
      ...(!id ? { destinationMerchandiseWeightAt: new Date() } : {}),
      destinationTruckWeight: 0,
      ...(!id ? { destinationTruckWeightAt: new Date() } : {}),
      deliveryFeeByWeight: 0,
      deliveryFeeExternal: 0,
      truckId: null,
      type: 'IN',
      unitPrice: 1,
      billPictures: [],
      finalMerchandiseWeightCol: 'departure',
      ingredientPriceHistoryId: null,
      location: 'INTERNAL',
      pack: 0,
      createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
      currency: 'VND',
      contractId: null,
      isExchangeInternalInventory: false,
      deliveryProviderId: null,
      commissions: [],
    },
    shouldFocusError: true,
    mode: 'onChange'
  });
  const {
    reset,
    getValues,
    control,
    register,
    errors,
    handleSubmit,
  } = methodForm;

  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);

  const [billData, setBillData] = useState();
  const [ingredientPriceHistoryOptions, setIngredientPriceHistoryOptions] =
    useState([]);
  const [userOptions, setUserOptions] = useState([]);

  const [haveRequestUpdate, setHaveRequestUpdate] = useState(null);
  const [showFormRequestUpdate, setShowFormRequestUpdate] = useState(false);
  const [externalContractOptions, setExternalContractOptions] = useState([]);


  useEffect(() => {
    if (billData) {
      const listIngredientPrice = [];
      if (billData.ingredientPriceHistoryId) {
        listIngredientPrice.push({
          label: renderLabelIngredientPriceHistoryOption(
            billData.ingredientPriceHistory
          ),
          value: billData.ingredientPriceHistoryId,
          data: billData.ingredientPriceHistory,
        });
      }

      GET(
        `ingredient-price-history`,
        {
          customerId: billData.customerId,
          ingredientId: billData.ingredientId,
          type: billData.type,
          status: 'APPROVED',
        },
        true
      ).then((resp) => {
        const {
          data: { rows },
        } = resp;
        rows.forEach((row) => {
          if (row.id !== billData.ingredientPriceHistoryId) {
            listIngredientPrice.push({
              label: renderLabelIngredientPriceHistoryOption(row),
              value: row.id,
              data: row,
            });
          }
          setIngredientPriceHistoryOptions(listIngredientPrice);
        });
      });
    }
  }, [billData]);


  useEffect(() => {
    if (id) {
      GET(`/bill/${id}`, {}, true).then((resp) => {
        let {
          data: { haveRequestUpdate, ...data },
        } = resp;
        if (duplicateId) {
          data.id = `${data.id}-${moment().valueOf()}`;
        }
        if (haveRequestUpdate) {
          setHaveRequestUpdate(haveRequestUpdate);
        }

        const allowedIngredients = [
          ...Object.values(EXTERNAL_PORT_FEE_CATEGORY_ID),
        ]
        if (!allowedIngredients.includes(data.ingredientId)) {
          toast.error("Đơn hàng không hợp lệ!");
          history.goBack();
          return;
        }

        reset({
          ...data,
          createdAt: moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        });
        setBillData(data);
      });
    }
  }, [params, search]);

  useEffect(() => {
    GET("/user/list-can-confirm-request-update", {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

    GET("/bill-external-contract/", {
      notCompleted: true,
    }, true).then(({ data }) => {
      setExternalContractOptions([
        ...data?.rows?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        })),
      ]);
    });

  }, []);



  const parseDataSubmit = (data) => {
    let {
      ingredientId,
      status,
      customerId,
      customerName,
      note,
      reason,
      reviewerId,
      billExternalContractId,
      unitPrice,
      createdAt
    } = data;

    const formData = {
      numOfContainer: 0,
      departureTotalWeight: 1,
      ...(!id
        ? { departureTotalWeightAt: new Date() }
        : {}),
      departureMerchandiseWeight: 1,
      ...(!id ? { departureMerchandiseWeightAt: new Date() }
        : {}),
      departureTruckWeight: 0,
      ...(!id ? { departureTruckWeightAt: new Date() } : {}),

      destinationTotalWeight: 1,
      ...(!id ? { destinationTotalWeightAt: new Date() } : {}),
      destinationMerchandiseWeight: 1,
      ...(!id ? { destinationMerchandiseWeightAt: new Date() } : {}),
      destinationTruckWeight: 0,
      ...(!id ? { destinationTruckWeightAt: new Date() } : {}),
      deliveryFeeByWeight: 0,
      deliveryFeeExternal: 0,
      ingredientId,
      status,
      truckId: null,
      type: 'IN',
      unitPrice,
      customerId,
      customerName,
      billPictures: [],
      finalMerchandiseWeightCol: 'departure',
      ingredientPriceHistoryId: null,
      location: 'INTERNAL',
      note,
      pack: 0,
      createdAt,
      currency: 'VND',
      contractId: null,
      reason,
      reviewerId,
      isExchangeInternalInventory: false,
      deliveryProviderId: null,
      billExternalContractId,
      commissions: [],
    };
    return formData;
  };

  const onHandleSubmit = () => {
    const { id: newId } = getValues();
    setLoading(true);
    const formData = parseDataSubmit(getValues());
    const request =
      id && !duplicateId
        ? PUT(`bill/${id}`, formData, {}, true)
        : POST("bill", { ...formData, id: newId }, {}, true);

    request
      .then((res) => {
        if (id) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        history.goBack();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onRequestUpdate = () => {
    setLoading(true);
    const formData = parseDataSubmit(getValues());
    PUT(`/bill/request-update-bill/${id}`, formData, {}, true)
      .then((res) => {
        toast.success("Gửi yêu cầu thành công");
        history.goBack();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (!billData && !!id) {
    return <></>;
  }

  return (
    <React.Fragment>
      <Head title="Đơn hàng"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đơn hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <FormProvider {...methodForm}>
                    <BillExternalPortFeeCreateForm
                      id={id}
                      duplicateId={id}
                      billData={billData}
                      ingredientPriceHistoryOptions={ingredientPriceHistoryOptions}
                      externalContractOptions={externalContractOptions}
                      setLoading={setLoading}
                    />

                    {showFormRequestUpdate ? (
                      <Row>
                        <Col md="6">
                          <div className="form-group">
                            <label className="form-label" htmlFor="customer">
                              Người duyệt
                              <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="reviewerId"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    classNamePrefix="form-control"
                                    inputRef={ref}
                                    name={name}
                                    options={userOptions}
                                    value={userOptions.find(
                                      (c) => c.value === value
                                    )}
                                    onChange={(val) => onChange(val.value)}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="reviewerId"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col size="12">
                          <div className="form-group">
                            <label className="form-label" >
                              Lý do cập nhật
                              <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <textarea
                                rows={3}
                                className="form-control"
                                style={{ height: "unset" }}
                                name="reason"
                                ref={register({
                                  required: "Vui lòng nhập thông tin",
                                })}
                                disabled={haveRequestUpdate}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="reason"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                            <div className="mt-2">
                              <Button
                                disabled={haveRequestUpdate}
                                color="primary"
                                type="button"
                                className={"mr-2"}
                                onClick={handleSubmit(onRequestUpdate)}
                              >
                                <span>Gửi yêu cầu cập nhật</span>
                              </Button>
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setShowFormRequestUpdate(false)}
                              >
                                <span>Ẩn yêu cầu sửa đơn hàng</span>
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col size="12" className={"mt-4"}>
                          <Button
                            className={`mr-2`}
                            color="primary"
                            type="button"
                            onClick={handleSubmit(onHandleSubmit)}
                            disabled={loading}
                          >
                            <span>Lưu đơn hàng</span>
                          </Button>
                          {!duplicateId && id ? (
                            <Button
                              color="primary"
                              type="button"
                              onClick={() => setShowFormRequestUpdate(true)}
                            >
                              <span>Hiện yêu cầu sửa đơn hàng</span>
                            </Button>
                          ) : (
                            <></>
                          )}
                        </Col>
                      </Row>
                    )}
                    <BillHistory />
                  </FormProvider>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default BillExternalPortFeeCreate;
